export default {
  state: {
    info: {}
  },
  mutations: {
    'SET_ACCOUNT' (state, account) {
      state.info = account
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js